module.exports = __webpack_public_path__ + "static/media/flexline_black_logo_en.e0fd8976.png";